export const Signup = `
mutation SignUp($firstname: String!, $lastname: String!, $password: String!, $email: String!, $phonenumber: String) {
  signUp(firstname: $firstname, lastname: $lastname, password: $password, email: $email, phonenumber: $phonenumber) {
    userid
    firstname
    lastname
    email
    password
    phonenumber
    deleted
    createdAt
    updatedAt
  }
}`;

export const SignIn = `mutation SignIn($email: String!, $password: String!) {
  signIn(email: $email, password: $password) {
    userid
    firstname
    lastname
    email
    password
    phonenumber
    deleted
    createdAt
    updatedAt
  }
}`;

export const ForgetPassword = `mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}`;

export const resetPassword = `mutation ResetPassword($userid: ID!, $password: String!) {
  resetPassword(userid: $userid, password: $password)
}`;

export const EditUser = `mutation EditUser($userid: ID!, $firstname: String, $lastname: String, $password: String, $phonenumber: String) {
  editUser(userid: $userid, firstname: $firstname, lastname: $lastname, password: $password, phonenumber: $phonenumber)
}`;

export const UserById = `query UserById($userid: ID!) {
  userById(userid: $userid) {
    userid
    firstname
    lastname
    email
    password
    phonenumber
    deleted
    createdAt
    updatedAt
  }
}`;

export const RegisterStudent = `mutation RegisterStudent($schoolname: String!, $grade: Int!, $userid: ID!, $formdata: String, $subject: Int) {
  registerStudent(schoolname: $schoolname, grade: $grade, userid: $userid, formdata: $formdata, subject: $subject) {
    userid
    schoolid
    schoolname
    grade
    formdata
    subject
  }
}`;

export const EditStudent = `mutation EditStudent($schoolid: ID!, $schoolname: String, $grade: Int, $formdata: String, $subject: Int) {
  editStudent(schoolid: $schoolid, schoolname: $schoolname, grade: $grade, formdata: $formdata, subject: $subject)
}`;

export const SchoolDataByUserId = `query SchoolDataByUserId($userid: ID!) {
  schoolDataByUserId(userid: $userid) {
    userid
    schoolid
    schoolname
    grade
    formdata
    subject
  }
}`;